import script from "./edit-tenant-payment-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-tenant-payment-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__